import {
  hideAlertbox,
  showAlertbox,
} from '../../../redux/actions/general/alertbox';
import { setNotification } from '../../../redux/actions/general/notification';
import { readTask } from '../../../redux/actions/table/all_tasks';
import { __, setTableParams } from '../../../core/utils';

export const openRelationTask = (task, match) => {
  if (!task?.can_view || !task?.id) {
    return;
  }

  if (match.path === '/stages/:stage/tasks') {
    setTableParams('all_tasks', {
      clicked_row: task.id,
    });
  } else {
    readTask(task.id);
  }
};

export const refreshTaskFlyout = (taskId, match) =>
  readTask(taskId).then(() => {
    if (match.path === '/meetings/:meeting') {
      setTableParams('all_tasks', {
        clicked_row: taskId,
      });
    }
  });

export const confirmRelationRemoval = ({
  description,
  notification,
  remove,
  taskId,
  match,
}) => {
  showAlertbox({
    color: 'red',
    title: __('general.alert.are-you-sure'),
    description,
    buttons: [
      {
        color: 'lightGray',
        text: __('general.alert.no-close'),
        onClick: 'close',
      },
      {
        color: 'gray',
        text: __('general.alert.yes-remove'),
        onClick: () =>
          remove()
            .then(() => refreshTaskFlyout(taskId, match))
            .then(() => {
              hideAlertbox();
              setNotification(notification);
            }),
      },
    ],
  });
};
